// 维修管理
const platformMaintain = (resolve) => {
  import('components/platform/platform.maintainManage').then((module) => {
    resolve(module)
  })
}
// 固件信息
const firmwareInfo = (resolve) => {
  import('components/reports/reports.firmwareInfo').then((module) => {
    resolve(module)
  })
}
// 设备变更报表
const reportsUserDevUpdate = (resolve) => {
  import('components/operation/operation.UserDevUpdate').then((module) => {
    resolve(module)
  })
}

// =====报表统计
// 车辆状态---上下线
const onOffSummery = (resolve) => {
  import('components/reports/reports.onofflineSummery').then((module) => {
    resolve(module)
  })
}
// 车辆状态---上下线
const onOffDetail = (resolve) => {
  import('components/reports/reports.onofflineDetail').then((module) => {
    resolve(module)
  })
}
// 车辆状态---上线率报表
const onProbability = (resolve) => {
  import('components/reports/reports.onofflineRate').then((module) => {
    resolve(module)
  })
}
// 车辆状态-超时停车汇总表
const alarmParkingOvertimeSummery = (resolve) => {
  import('components/reports/reports.ParkingOvertimeSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-停车未熄火汇总表
const alarmParkingNSDSummery = (resolve) => {
  import('components/reports/reports.ParkingNSDSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-停车未熄火明细表
const alarmParkingNSDdetail = (resolve) => {
  import('components/reports/reports.ParkingNSDdetail').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车明细表
const alarmParkingOvertimeDetail = (resolve) => {
  import('components/reports/reports.ParkingOvertimeDetail').then((module) => {
    resolve(module)
  })
}
// 轨迹分析数据报表
const gpsTrackFailure = (resolve) => {
  import('components/alarm/alarm.gpsTrackFailure').then((module) => {
    resolve(module)
  })
}
// 轨迹漂点明细报表
const driftPoints = (resolve) => {
  import('components/alarm/alarm.driftPoints').then((module) => {
    resolve(module)
  })
}// 定位不连续明细
const positioningDiscontinuity = (resolve) => {
  import('components/alarm/alarm.positioningDiscontinuity').then((module) => {
    resolve(module)
  })
}
// 异常不在线设备统计
const abnormalStatus = (resolve) => {
  import('components/alarm/alarm.abnormalStatus').then((module) => {
    resolve(module)
  })
}
// 设备实时录像状态
const devRealTimeRecordingStatus = (resolve) => {
  import('components/alarm/alarm.devRealTimeRecordingStatus').then((module) => {
    resolve(module)
  })
}
// 平台电子围栏-围栏报警明细表
const alarmFenceDetail = (resolve) => {
  import('components/reports/reports.FenceDetail').then((module) => {
    resolve(module)
  })
}
// 平台电子围栏-围栏报警汇总表
const alarmFenceSummery = (resolve) => {
  import('components/reports/reports.FenceSummery').then((module) => {
    resolve(module)
  })
}
// 终端电子围栏-围栏报警明细表
const alarmDeviceFenceDetail = (resolve) => {
  import('components/reports/reports.DeviceFenceDetail').then((module) => {
    resolve(module)
  })
}
// 终端电子围栏-围栏报警汇总表
const alarmDeviceFenceSummery = (resolve) => {
  import('components/reports/reports.DeviceFenceSummery').then((module) => {
    resolve(module)
  })
}
// 海外司机刷卡---R海外司机刷卡明细表
const alarmDriverDetail = (resolve) => {
  import('components/reports/reports.driverDetail').then((module) => {
    resolve(module)
  })
}
// 固件相关-固件报警汇总
const alarmAlarmSummery = (resolve) => {
  import('components/alarm/alarm.AlarmSummery').then((module) => {
    resolve(module)
  })
}
// 固件相关-报警详情
const AlarmDetail2 = (resolve) => {
  import('components/alarm/alarm.AlarmDetail2').then((module) => {
    resolve(module)
  })
}
// 外设相关---客流量统计
const trafficSummeryNew = (resolve) => {
  import('components/reports/reports.TrafficSummeryNew').then((module) => {
    resolve(module)
  })
}
// 外设相关-油量动态明细表
const oilDynamicDetail = (resolve) => {
  import('components/reports/reports.OilDynamicDetail').then((module) => {
    resolve(module)
  })
}
// 外设相关-油量异常明细表
const oilUnusualDetail = (resolve) => {
  import('components/reports/reports.OilUnusualDetail').then((module) => {
    resolve(module)
  })
}
// 外设相关-油量日统计表
const oilDaily = (resolve) => {
  import('components/reports/reports.OilDaily').then((module) => {
    resolve(module)
  })
}
// 胎压报表-胎压传感器明细表
const reportsTyreDetail = (resolve) => {
  import('components/reports/reports.TyreDetail').then((module) => {
    resolve(module)
  })
}
// 常用报表---里程汇总报表
const reportsNormalSummery = (resolve) => {
  import('components/reports/reports.normalSummery').then((module) => {
    resolve(module)
  })
}

// 常用报表---里程日报表
const reportsNormalDetail = (resolve) => {
  import('components/reports/reports.normalDetail').then((module) => {
    resolve(module)
  })
}
// 行驶记录仪
const drivingrecord = (resolve) => {
  import('components/reports/reports.drivingrecord').then((module) => {
    resolve(module)
  })
}
// ETC记录管理
const etcrecord = (resolve) => {
  import('components/reports/reports.etcCardInfoDtl').then((module) => {
    resolve(module)
  })
}
// ETC交易记录管理
const etcBillrecord = (resolve) => {
  import('components/reports/reports.etcTransactionBillDtl').then((module) => {
    resolve(module)
  })
}
// ETC报警管理
const etcAlarmInfo = (resolve) => {
  import('components/reports/reports.etcAlarmInfo').then((module) => {
    resolve(module)
  })
}
// 温度报表
const temperature = (resolve) => {
  import('components/reports/reports.temperature').then((module) => {
    resolve(module)
  })
}
// IO输入报警报表---IO输入报警汇总报表
const alarmIoSummery = (resolve) => {
  import('components/alarm/alarm.IoSummery').then((module) => {
    resolve(module)
  })
}
// IO输入报警报表---IO输入报警明细报表
const alarmIoDetail = (resolve) => {
  import('components/alarm/alarm.IoDetail').then((module) => {
    resolve(module)
  })
}
// 多媒体-图片
const reportsMultimideaPicture = (resolve) => {
  import('components/reports/reports.MultimideaPicture').then((module) => {
    resolve(module)
  })
}
// 多媒体-音频
const reportsMultimideaAudio = (resolve) => {
  import('components/reports/reports.MultimideaAudio').then((module) => {
    resolve(module)
  })
}
// 多媒体-视频
const reportsMultimideaVideo = (resolve) => {
  import('components/reports/reports.MultimideaVideo').then((module) => {
    resolve(module)
  })
}
// 设备信息-车辆版本明细表
const reportsVehicleRelease = (resolve) => {
  import('components/reports/reports.VehicleReleaseDetails').then((module) => {
    resolve(module)
  })
}
// 设备信息-设备离线任务记录报表
const reportsVehicleRecordingUpgrade = (resolve) => {
  import('components/reports/reports.VehicleRecordingUpgrade').then((module) => {
    resolve(module)
  })
}
// 设备信息-设备离线任务状态报表
const reportsVehicleRecordingUpgradeStatus = (resolve) => {
  import('components/reports/reports.VehicleRecordingUpgradeStatus').then((module) => {
    resolve(module)
  })
}
// 设备信息-车辆MCU报表
const reportsVehicleMCU = (resolve) => {
  import('components/reports/reports.VehicleMCUDetails').then((module) => {
    resolve(module)
  })
}
// 物流表-操作记录
const reportsOperationRecordDtl = (resolve) => {
  import('components/reports/reports.OperationRecord').then((module) => {
    resolve(module)
  })
}
// 物流表-报警记录
const reportsAlarmRecordDtl = (resolve) => {
  import('components/reports/reports.alarmRecord').then((module) => {
    resolve(module)
  })
}
// 围栏报警
const platformFence = (resolve) => {
  import('components/platform/platform.fenceAlarm').then((module) => {
    resolve(module)
  })
}
// 路线偏移
const platformRouteDeviation = (resolve) => {
  import('components/platform/platform.routeDeviation').then((module) => {
    resolve(module)
  })
}

// ====系统管理
// 用户行为分析-用户操作汇总
const reportsUserOperationSummary = (resolve) => {
  import('components/operation/operation.UserOperationSummary').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户操作日志
const reportsUserOperationLog = (resolve) => {
  import('components/operation/operation.UserOperationLog').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户媒体汇总
const reportsUserMediaSummary = (resolve) => {
  import('components/operation/operation.UserMediaSummary').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户媒体明细
const reportsUserMediaDetail = (resolve) => {
  import('components/operation/operation.UserMediaDetail').then((module) => {
    resolve(module)
  })
}
// 服务器日志
const serverLog = (resolve) => {
  import('components/server/server.serverLog').then((module) => {
    resolve(module)
  })
}
// 未打表报警
const notPlaying = (resolve) => {
  import('components/reports/reports.notPlaying.vue').then((module) => {
    resolve(module)
  })
}
const statisticalAnalyCompany = (resolve) => {
  import('components/alarm/alarm.statisticalAnalyCompany').then((module) => {
    resolve(module)
  })
}
const statisticalAnalyVehicle = (resolve) => {
  import('components/alarm/alarm.statisticalAnalyVehicle').then((module) => {
    resolve(module)
  })
}

const allRouter = {
  allPath: [
    {
      path: '/all/firmware/maintainManage', // 维修管理
      component: platformMaintain
    },
    {
      path: '/all/firmwareInfo/firmwareInfo', // 固件信息查询
      component: firmwareInfo
    },
    {
      path: '/all/firmware/UserDevUpdate', // 设备变更报表
      component: reportsUserDevUpdate
    },
    // 报表统计
    {
      path: '/all/carState/onOffSummery', // 车辆状态---上下线
      component: onOffSummery
    },
    {
      path: '/all/carState/OnOffDetail', // 上下线汇总表
      component: onOffDetail
    },
    {
      path: '/all/carState/OnProbability', // 上下线汇总表
      component: onProbability
    },
    {
      path: '/all/carState/alarmParkingNSDSummery', // 停车未熄火汇总表(停车报表)
      component: alarmParkingNSDSummery
    },
    {
      path: '/all/carState/alarmParkingNSDdetail', // 停车未熄火明细表(停车报表)
      component: alarmParkingNSDdetail
    },
    {
      path: '/all/carState/alarmParkingOvertimeSummery', // 超时停车汇总表(停车报表)
      component: alarmParkingOvertimeSummery
    },
    {
      path: '/all/carState/alarmParkingOvertimeDetail', // 超时停车明细表(停车报表)
      component: alarmParkingOvertimeDetail
    },
    {
      path: '/all/carState/gpsTrackFailure', // 轨迹分析数据报表
      component: gpsTrackFailure
    },
    {
      path: '/all/carState/driftPoints', // 轨迹漂点明细报表
      component: driftPoints
    },
    {
      path: '/all/carState/positioningDiscontinuity', // 定位不连续明细
      component: positioningDiscontinuity
    },
    {
      path: '/all/carState/abnormalStatus', // 异常不在线设备统计
      component: abnormalStatus
    },
    {
      path: '/all/carState/devRealTimeRecordingStatus', // 设备实时录像状态
      component: devRealTimeRecordingStatus
    },
    {
      path: '/all/line/FenceDetail', // 平台围栏报警明细表(电子围栏)
      component: alarmFenceDetail
    },
    {
      path: '/all/line/FenceSummery', // 平台围栏报警汇总表(电子围栏)
      component: alarmFenceSummery
    },
    {
      path: '/all/line/DeviceFenceDetail', // 终端围栏报警明细表(电子围栏)
      component: alarmDeviceFenceDetail
    },
    {
      path: '/all/line/DeviceFenceSummery', // 终端围栏报警汇总表(电子围栏)
      component: alarmDeviceFenceSummery
    },
    {
      path: '/all/peri/AlarmDriverDetail', // 终端围栏报警汇总表(电子围栏)
      component: alarmDriverDetail
    },
    {
      path: '/all/firmware/alarmAlarmSummery', // 固件相关-固件报警汇总
      component: alarmAlarmSummery
    },
    {
      path: '/all/firmware/AlarmDetail2/:id', // 固件相关-报警详情
      component: AlarmDetail2
    },
    {
      path: '/all/carState/AlarmDetail2/:id', // 车辆状态-报警详情
      component: AlarmDetail2
    },
    {
      path: '/all/peri/AlarmDetail2/:id', // 传感器及外设相关-报警详情
      component: AlarmDetail2
    },
    {
      path: '/all/driverSafety/AlarmDetail2/:id', // 司机安全行为相关-报警详情
      component: AlarmDetail2
    },
    {
      path: '/all/carSafety/AlarmDetail2/:id', // 车辆安全相关-报警详情
      component: AlarmDetail2
    },
    {
      path: '/all/line/AlarmDetail2/:id', // 电子围栏报警-报警详情
      component: AlarmDetail2
    },
    {
      path: '/all/peri/trafficSummeryNew', // 外设相关-客流量统计
      component: trafficSummeryNew
    },
    {
      path: '/all/peri/OilDynamicDetail', // 油量动态明细表(油量报表)
      component: oilDynamicDetail
    },
    {
      path: '/all/peri/OilUnusualDetail', // 油量异常明细表(油量报表)
      component: oilUnusualDetail
    },
    {
      path: '/all/peri/OilDaily', // 油量日统计表(油量报表)
      component: oilDaily
    },
    {
      path: '/all/peri/TyreDetail', // 胎压传感器
      component: reportsTyreDetail
    },
    {
      path: '/all/carState/normalSummery', // 里程汇总报表
      component: reportsNormalSummery
    },
    {
      path: '/all/carState/normalDetail', // 里程日报表
      component: reportsNormalDetail
    },
    {
      path: '/all/peri/drivingrecord', // 行驶记录仪
      component: drivingrecord
    },
    {
      path: '/all/peri/etcCardInfoDtl', // ETC记录管理
      component: etcrecord
    },
    {
      path: '/all/peri/etcTransactionBillDtl', // ETC交易记录管理
      component: etcBillrecord
    },
    {
      path: '/all/peri/etcAlarmInfo', // ETC报警管理
      component: etcAlarmInfo
    },
    {
      path: '/all/peri/temperature', // 温度报表
      component: temperature
    },
    {
      path: '/all/peri/IoSummery', // IO输入报警汇总报表(IO输入报警报表)
      component: alarmIoSummery
    },
    {
      path: '/all/peri/IoDetail', // IO输入报警明细报表(IO输入报警报表)
      component: alarmIoDetail
    },
    {
      path: '/all/multimedia/MultimideaPicture', // 图片(多媒体)
      component: reportsMultimideaPicture
    },
    {
      path: '/all/multimedia/MultimideaAudio', // 音频(多媒体)
      component: reportsMultimideaAudio
    },
    {
      path: '/all/multimedia/MultimideaVideo', // 视频(多媒体)
      component: reportsMultimideaVideo
    },
    {
      path: '/all/peri/reportsOperationRecordDtl', // 操作记录
      component: reportsOperationRecordDtl
    },
    {
      path: '/all/peri/reportsAlarmRecordDtl', // 报警记录
      component: reportsAlarmRecordDtl
    },
    {
      path: '/all/line/fence', // 围栏报警
      component: platformFence
    },
    {
      path: '/all/line/routeDeviation', // 路线偏移
      component: platformRouteDeviation
    },
    {
      path: '/all/log/UserOperationSummary', // 用户操作汇总(用户行为分析)
      component: reportsUserOperationSummary,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/all/log/UserOperationLog', // 用户操作日志(用户行为分析)
      component: reportsUserOperationLog,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/all/log/UserMediaSummary', // 用户媒体汇总(用户行为分析)
      component: reportsUserMediaSummary,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/all/log/UserMediaDetail', // 用户媒体明细(用户行为分析)
      component: reportsUserMediaDetail,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/all/log/serverLog', // 服务器日志
      component: serverLog,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/all/firmwareInfo/reportsVehicleRelease', //  设备信息(车辆版本明细表)
      component: reportsVehicleRelease
    },
    {
      path: '/all/firmwareInfo/reportsVehicleRecordingUpgrade', //  设备信息(设备离线任务记录报表)
      component: reportsVehicleRecordingUpgrade
    },
    {
      path: '/all/firmwareInfo/reportsVehicleRecordingUpgradeStatus', //  设备信息(设备离线任务状态报表)
      component: reportsVehicleRecordingUpgradeStatus
    },
    {
      path: '/all/firmwareInfo/VehicleMCUDetails', // 设备信息(车辆MCU报表)
      component: reportsVehicleMCU
    },
    {
      path: '/all/notPlay/notPlaying', // 未打表报警
      component: notPlaying
    },
    {
      path: '/all/notPlay/statisticalAnalyCompany', // 企业未打表统计
      component: statisticalAnalyCompany
    },
    {
      path: '/all/notPlay/statisticalAnalyVehicle', // 车辆未打表统计
      component: statisticalAnalyVehicle
    }
  ]
}

export default allRouter



// WEBPACK FOOTER //
// ./src/router/all.js